var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 100 60",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:sketch": "http://www.bohemiancoding.com/sketch/ns",
        width: "100%",
        height: "100%",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Icons:-Credit-card",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            "sketch:type": "MSPage",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Visa-card-light",
                "sketch:type": "MSArtboardGroup",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Credit-Card/Visa/Visa-card-light",
                    "sketch:type": "MSLayerGroup",
                  },
                },
                [
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      fill: "#FFFFFF",
                      "sketch:type": "MSShapeGroup",
                      x: "0",
                      y: "0",
                      width: "100",
                      height: "60",
                      rx: "4",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M41.4899908,39.5467606 L44.5647281,20.4726761 L49.4795853,20.4726761 L46.405129,39.5467606 L41.4899908,39.5467606",
                      id: "Fill-1",
                      fill: "#26337A",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M64.232871,20.9408451 C63.2610876,20.5580282 61.7327143,20.1405634 59.8287834,20.1405634 C54.9695853,20.1405634 51.5490876,22.7290141 51.5206959,26.435493 C51.4897742,29.1771831 53.9615392,30.7061972 55.8249908,31.6174648 C57.7401659,32.5515493 58.3836175,33.1492958 58.3760276,33.984507 C58.3628157,35.2619718 56.8473733,35.8473239 55.4342535,35.8473239 C53.4665115,35.8473239 52.4210783,35.5591549 50.8047189,34.8470423 L50.1725115,34.5433803 L49.4852074,38.8129577 C50.6312765,39.3442254 52.7558756,39.8053521 54.960871,39.8295775 C60.1250691,39.8295775 63.4806313,37.2723944 63.5199862,33.3143662 C63.5376959,31.1402817 62.228023,29.4923944 59.3916636,28.131831 C57.674106,27.2473239 56.6199585,26.6614085 56.6320461,25.7661972 C56.6331705,24.9735211 57.5225899,24.1247887 59.4476037,24.1247887 C61.0552488,24.0988732 62.2190276,24.4701408 63.1258756,24.8577465 L63.567212,25.0757746 L64.232871,20.9408451",
                      id: "Fill-2",
                      fill: "#26337A",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M70.7772995,32.7842254 C71.1846221,31.6878873 72.7352028,27.4526761 72.7352028,27.4526761 C72.70653,27.5030986 73.1402765,26.3478873 73.3884931,25.6329577 L73.7201982,27.2780282 C73.7201982,27.2780282 74.6633088,31.8307042 74.857553,32.7842254 L70.7772995,32.7842254 L70.7772995,32.7842254 Z M76.8407558,20.4921127 L73.0424516,20.4921127 C71.8643364,20.4921127 70.9825069,20.8295775 70.4663963,22.0732394 L63.1674793,39.5535211 L68.3297097,39.5535211 C68.3297097,39.5535211 69.1719032,37.2019718 69.3630553,36.6859155 C69.9261106,36.6859155 74.9421659,36.6957746 75.6581429,36.6957746 C75.8054424,37.3614085 76.2566175,39.5535211 76.2566175,39.5535211 L80.8184055,39.5535211 L76.8407558,20.4921127 L76.8407558,20.4921127 Z",
                      id: "Fill-3",
                      fill: "#26337A",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M37.3667281,20.4887324 L32.5561613,33.4926761 L32.040894,30.8492958 C31.144447,27.803662 28.3539078,24.5025352 25.2325069,22.8484507 L29.6335023,39.5301408 L34.8350876,39.5270423 L42.5750599,20.4887324 L37.3667281,20.4887324",
                      id: "Fill-4",
                      fill: "#26337A",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M28.0905115,20.4757746 L20.1647281,20.4757746 L20.0995115,20.8709859 C26.2666959,22.4509859 30.3472304,26.2647887 32.040894,30.8492958 L30.3185576,22.0850704 C30.0214286,20.876338 29.157871,20.5180282 28.0905115,20.4757746",
                      id: "Fill-5",
                      fill: "#ED982D",
                      "sketch:type": "MSShapeGroup",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }